export interface IssueDetailTableValue {
    issueId: string;
    name: string;
    state: TaskState;
    dueDate?: Date;
}
export enum TaskState {
    NOT_APPLICABLE = -1,
    OPEN = 0,
    IN_PROGRESS = 50,
    IN_REVIEW = 80,
    DONE = 100,
}
